import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import { observer } from "mobx-react";

import { TextField, If } from "components/support";

class ProductStockInfo extends Component {
  render() {
    const { product, mode /* canEditStockCount */ } = this.props;

    return (
      <div className="grid-container">
        <Row>
          <Col xs={12}>
            <div className="grid-container mt-sm mb-sm">
              <Row>
                <Col xs={12} lg={6}>
                  <TextField
                    fullWidth
                    value={product.restock_count}
                    label="Estoque Mínimo"
                    onChange={(_, value) => (product.restock_count = value)}
                  />
                </Col>
                <If test={mode === "add" /* || canEditStockCount */}>
                  <Col xs={12} lg={6}>
                    <TextField
                      fullWidth
                      value={product.stock_count}
                      label="Quantidade Atual"
                      onChange={(_, value) => (product.stock_count = value)}
                    />
                  </Col>
                </If>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default observer(ProductStockInfo);



// WEBPACK FOOTER //
// ./src/components/app/registration/product/form/stock-info/index.jsx